import React from "react";

import { SERVICES } from "./../../configs/constants";

import { exportTransferOrder } from "../../lib/api/providers";
import AuthRender from "../../containers/AuthRender";

const GenerateTransferOrder = ({ handleTransferOrderGenerated, token, params }) => {
  const [isDisabled, setIsDisabled] = React.useState(false);

  const getTransferOrder = async (filters = {}, token) => {
    await exportTransferOrder
      .post(
        "/",
        { ...filters },
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: token
          }
        }
      )
      .then(() => {
        handleTransferOrderGenerated();
      });
  };

  return (
    <AuthRender service={SERVICES.Virement} access={["export"]}>
      <div
        className={`${
          isDisabled ? "bg-gray-400" : "bg-green-400"
        } rounded-full text-white py-3 px-4 mx-2 cursor-pointer`}
        onClick={async () => {
          if (isDisabled) return;
          setIsDisabled(true);
          await getTransferOrder(params, token);
          await setTimeout(() => {
            setIsDisabled(false);
          }, 5000);
        }}
      >
        Générer un ordre de virement
      </div>
    </AuthRender>
  );
};

export default GenerateTransferOrder;



// WEBPACK FOOTER //
// src/components/generateTransferOrder/GenerateTransferOrder.js